import config from "@/api/config";
import Qs from "qs";
import urlName from "@/api/urlName";
import { get, post, getJava, postJava, postJava2, putJava } from "./api";
import ResultValue from "@/model/ResultValue";
import LoginParam from "@/model/LoginParam";
import LoginResultBean from "@/model/LoginResultBean";
import MenuList from "@/model/MenuList";
import GetCustomerListObj from "@/model/GetCustomerListObj";
import CustomerList from "@/model/CustomerList";
import GetVehicleManagementListObj from "@/model/GetVehicleManagementListObj";
import AddCarClientParam from "@/model/AddCarClientParam";
import VehicleVINList from "@/model/VehicleVINList";
import GetWorkStationListObj from "@/model/GetWorkStationListObj";
import WorkStationList from "@/model/WorkStationList";
import EditWorkStationParams from "@/model/EditWorkStationParams";
import AddWorkStation from "@/model/AddWorkStation";
import BindUserPram from "@/model/BindUserPram";
import BindUserParams from "@/model/BindUserParams";
import DelBindUserParams from "@/model/DelBindUserParams";
import VehicleManagementList from "@/model/VehicleManagementList";
import RequetsUserList from "@/model/RequetsUserList";
import UserList from "@/model/UserList";
import GetUserCarsParams from "@/model/GetUserCarsParams";
import UserCarsInfoList from "@/model/UserCarsInfoList";
import AddOrgUserParam from "@/model/AddOrgUserParam";
import UserPram from "@/model/UserPram";
import RoleDetail from "@/model/RoleDetail";
import ResultBean from "@/model/ResultBean";
import RequestUserIds from "@/model/RequestUserIds";
import CarsListObj from "@/model/GetCarsListObj";
import VehicleList from "@/model/VehicleList";
import ScheduledTasksObj from "@/model/ScheduledTasksObj";
import ScheduledTasksList from "@/model/ScheduledTasksList";
import BasicInfoParameter from "@/model/BasicInfoParameter";
import BasicInfoResultBean from "@/model/BasicInfoResultBean";
import PasswordReset from "@/model/PasswordReset";
import { ChangeVehicleName } from "@/model/ChangeVehicleName";
import RequestVisualization from "@/model/RequestVisualization";
import ResultVisualization from "@/model/ResultVisualization";
import RequestCarsTaskStatisticsParam from "@/model/RequestCarsTaskStatisticsParam";
import CarsTaskStatisticsList from "@/model/CarsTaskStatisticsList";
import RequestCarsTaskStatistics from "@/model/RequestCarsTaskStatistics";
import RequestCarTaskStatistics from "@/model/RequestCarTaskStatistics";
import TaskStatisticsList from "@/model/TaskStatisticsList";
import CarDataStatisticsDetail from "@/model/CarDataStatisticsDetail";
import UserInfoResult from "@/model/UserInfoResult";
import UserInfo from "@/model/UserInfo";
import ChangePwInfo from "@/model/ChangePwInfo";
import KeywordParam from "@/model/KeywordParam";
import UserManageRes from "@/model/UserManageRes";
import RoleList from "@/model/RoleList";
import UserCarsParams from "@/model/UserCarsParams";
import AddUserParam from "@/model/AddUserParam";
import AddCustomer from "@/model/AddCustomer";
import EditCustomer from "@/model/EditCustomer";
import CustomerDetail from "@/model/CustomerDetail";
import unattendCarsListObj from "@/model/unattendCarsListObj";
import GetUnattendList from "@/model/GetUnattendList";
import AwakenStatus from "@/model/AwakenStatus";
import CleanTaskingInfo from "@/model/CleanTaskingInfo";
import VehiclePosition from "@/model/VehiclePosition";
import MapElement2 from "@/model/MapElement2";
import VehicleMapInfo from "@/model/VehicleMapInfo";
import snapList from "@/model/snapList";
import VinPram from "@/model/VinPram";
import CleanModeDetail from "@/model/CleanModeDetail";
import ErrorMsg from "@/model/ErrorMsg";
import DeviceInfoResponse from "@/model/DeviceInfoResponse";
import CleanInfoResponse from "@/model/CleanInfoResponse";
import EnergyUsageResponse from "@/model/EnergyUsageResponse";
import TaskCountResponse from "@/model/TaskCountResponse";
import TaskEndCountResponse from "@/model/TaskEndCountResponse";
import CleanAreaStatisticResponse from "@/model/CleanAreaStatisticResponse";
import CleanTimeStatisticResponse from "@/model/CleanTimeStatisticResponse";
import CleanRateStatisticResponse from "@/model/CleanRateStatisticResponse";
import FaultCountResponse from "@/model/FaultCountResponse";

const baseUrl = config.baseUrl.BASE_URL_PHP;
const urlToken = "?access-token=";
let token: string | null;
token = sessionStorage.getItem("token")
  ? sessionStorage.getItem("token")
  : (localStorage.getItem("token") as string);
//登录
// 登录
const logIn = (param: LoginParam): Promise<LoginResultBean> => {
  return new Promise<LoginResultBean>((resolve, reject) => {
    post(config.basicNode.node_2 + urlName.login, Qs.stringify(param))
      .then((value: ResultValue) => {
        const LoginResult = value.data as LoginResultBean;
        resolve(LoginResult);
      })
      .catch(() => {
        reject();
      });
  });
};
// 设置token
const setToken = (mToken: string): void => {
  token = mToken;
};

// 获取菜单列表
const getMenuList = (): Promise<MenuList> => {
  return new Promise<MenuList>((resolve, reject) => {
    post(config.basicNode.node_1 + urlName.get_menus_list + urlToken + token)
      .then((value: ResultValue) => {
        const result = value.data as MenuList;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 获取客户列表
const getCustomerList = (param: GetCustomerListObj): Promise<CustomerList> => {
  return new Promise<CustomerList>((resolve, reject) => {
    getJava(urlName.customer_list, param)
      .then((value: ResultValue) => {
        const carInfoList = value.data as CustomerList;
        resolve(carInfoList);
      })
      .catch(() => {
        reject();
      });
  });
};

// 客户-车辆管理列表
const getVehicleManagementList = (
  param: GetVehicleManagementListObj
): Promise<VehicleManagementList> => {
  return new Promise<VehicleManagementList>((resolve, reject) => {
    postJava(urlName.vehicle_management_list, param)
      .then((value: ResultValue) => {
        const VehicleManagementInfoList = value.data as VehicleManagementList;
        resolve(VehicleManagementInfoList);
      })
      .catch(() => {
        reject();
      });
  });
};

// 建立车辆与用户关系
const reserveCarClient = (param: AddCarClientParam): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    postJava(urlName.add_car_client, param)
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 解除车辆与用户关系
const removeCarClient = (param: AddCarClientParam): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    postJava(urlName.remove_car_client, param)
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 车辆管理vins列表
const getVehicleManagementVINList = (): Promise<VehicleVINList> => {
  return new Promise<VehicleVINList>((resolve, reject) => {
    post(
      config.basicNode.node_1 +
        urlName.vehicle_managementVIN_list +
        urlToken +
        token
    )
      .then((value) => {
        const vinList = value.data as VehicleVINList;
        resolve(vinList);
      })
      .catch(() => {
        reject();
      });
  });
};
// 工作站列表
const getWorkstationList = (
  param: GetWorkStationListObj
): Promise<WorkStationList> => {
  return new Promise<WorkStationList>((resolve, reject) => {
    postJava2(urlName.work_station_list, param)
      .then((value: ResultValue) => {
        const workStationInfoList = value.data as WorkStationList;
        resolve(workStationInfoList);
      })
      .catch(() => {
        reject();
      });
  });
};
// 编辑工作站
const editWorkStation = (param: EditWorkStationParams): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    postJava2(urlName.edit_workstation, param)
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 添加工作站
const addWorkStation = (param: AddWorkStation): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    postJava2(urlName.add_workstation, param)
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
//客户-用户列表
const getUserList = (param: RequetsUserList): Promise<UserList> => {
  return new Promise<UserList>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.org_user_list + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as UserList;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
//客户-用户列表-车辆列表
const getUserCars = (param: GetUserCarsParams): Promise<UserCarsInfoList> => {
  return new Promise<UserCarsInfoList>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.get_user_cars + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as UserCarsInfoList;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
//客户列表-用户管理
const getOrgUserLists = (param: RequetsUserList): Promise<UserList> => {
  return new Promise<UserList>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.get_org_user_lists + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as UserList;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
//获取待绑定用户列表
const getBindUserList = (param: BindUserPram): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.get_bind_user_list + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
//客户管理-添加客户（绑定）
const getBindUser = (param: BindUserParams): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.org_bind_user + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
//客户管理-批量删除用户关系
const delBindUser = (param: DelBindUserParams): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.del_user_status + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
//重置密码
const resetPasswd = (param: RequestUserIds): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.reset_passwd + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
//添加用户
const addOrgUser = (param: AddOrgUserParam): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.add_org_user + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
//获取区号列表
const getCountry = (): Promise<ResultBean> => {
  const param = {};
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.country_code + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
//获取全部角色-不分页
const getAllRolesList = (): Promise<ResultBean> => {
  const param = {};
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.allrole_list + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
//获取用户详情
const getOrgUserDetails = (param: UserPram): Promise<RoleDetail> => {
  return new Promise<RoleDetail>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.get_org_user_details + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as RoleDetail;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
//更改客户-用户状态
const changeUser = (param: RequestUserIds): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 +
        urlName.org_user_change_status +
        urlToken +
        token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 车辆列表
const getCarList = (param: CarsListObj): Promise<VehicleList> => {
  if (param) {
    param.category_name = "xdc"; //对应洗地车管理平台专有
  }
  return new Promise<VehicleList>((resolve, reject) => {
    get(config.basicNode.node_1 + urlName.car_list + urlToken + token, param)
      .then((value: ResultValue) => {
        const carInfoList = value.data as VehicleList;
        resolve(carInfoList);
      })
      .catch(() => {
        reject();
      });
  });
};
//定时任务列表
const getScheduledTasksList = (
  param: ScheduledTasksObj
): Promise<ScheduledTasksList> => {
  return new Promise<ScheduledTasksList>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.cron_task_list + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ScheduledTasksList;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 车辆详情
const getCarBasicInfo = (
  param: BasicInfoParameter
): Promise<BasicInfoResultBean> => {
  return new Promise<BasicInfoResultBean>((resolve, reject) => {
    get(config.basicNode.node_1 + urlName.basic_info + urlToken + token, param)
      .then((value: ResultValue) => {
        const result = value.data as BasicInfoResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
}; //重置车机app密码
const passwordReset = (param: PasswordReset): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.password_reset + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
//修改车辆名称
const changeVehicleName = (param: ChangeVehicleName): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.change_vn + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 软件版本信息
const carVersion = (
  param: BasicInfoParameter
): Promise<BasicInfoResultBean> => {
  return new Promise<BasicInfoResultBean>((resolve, reject) => {
    get(
      config.basicNode.node_1 + urlName.version_info + urlToken + token,
      param
    )
      .then((value: ResultValue) => {
        const result = value.data as BasicInfoResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 车辆硬件版本信息
const carHwVersion = (param: BasicInfoParameter) => {
  return new Promise<BasicInfoResultBean>((resolve, reject) => {
    get(
      config.basicNode.node_1 + urlName.hw_version_info + urlToken + token,
      param
    )
      .then((value: ResultValue) => {
        const result = value.data as BasicInfoResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
//车辆信息-资源统计的接口
const getVisualization = (
  param: RequestVisualization
): Promise<ResultVisualization> => {
  return new Promise<ResultVisualization>((resolve, reject) => {
    post(
      config.basicNode.node_1 +
        urlName.cars_source_statistics +
        urlToken +
        token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultVisualization;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
}; // 多车任务统计
const getCarsTaskStatistics = (
  param: RequestCarsTaskStatisticsParam
): Promise<CarsTaskStatisticsList> => {
  return new Promise<CarsTaskStatisticsList>((resolve, reject) => {
    post(
      config.basicNode.node_1 +
        urlName.get_cars_task_statistics +
        urlToken +
        token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as CarsTaskStatisticsList;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
const appendDownloadCarsTaskStatisticsParam = (
  param: RequestCarsTaskStatistics
): string => {
  let paramStr = "";
  if (param?.keyword) {
    paramStr += "&keyword=" + param?.keyword;
  }
  if (param?.start_time) {
    paramStr += "&start_time=" + param?.start_time;
  }
  if (param?.end_time) {
    paramStr += "&end_time=" + param?.end_time;
  }
  if (param?.vehicle_type) {
    paramStr += "&vehicle_type=" + param?.vehicle_type;
  }
  console.log("下载统计数据：", paramStr);
  return paramStr;
};
//下载数据统计列表
const downloadCarsTaskStatistics = (param: RequestCarsTaskStatistics): void => {
  window.location.href =
    baseUrl +
    config.basicNode.node_1 +
    urlName.download_cars_statistics +
    urlToken +
    token +
    appendDownloadCarsTaskStatisticsParam(param);
};
const appendDownloadTaskStatisticsParam = (
  param: RequestCarTaskStatistics
): string => {
  let paramStr = "";
  if (param?.vin) {
    paramStr += "&vin=" + param?.vin;
  }
  if (param?.start_time) {
    paramStr += "&start_time=" + param?.start_time;
  }
  if (param?.end_time) {
    paramStr += "&end_time=" + param?.end_time;
  }
  return paramStr;
};
//下载数据统计列表
const downloadTaskStatistics = (param: RequestCarTaskStatistics): void => {
  window.location.href =
    baseUrl +
    config.basicNode.node_1 +
    urlName.download_statistics +
    urlToken +
    token +
    appendDownloadTaskStatisticsParam(param);
};
//下载原始数据列表
const downloadRawCarsTaskStatistics = (
  param: RequestCarsTaskStatistics
): void => {
  window.location.href =
    baseUrl +
    config.basicNode.node_1 +
    urlName.download_raw_cars_statistics +
    urlToken +
    token +
    appendDownloadCarsTaskStatisticsParam(param);
};

// 获取车辆任务数据统计
const getCarTaskStatistics = (
  param: RequestCarTaskStatistics
): Promise<TaskStatisticsList> => {
  return new Promise<TaskStatisticsList>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.get_car_statistics + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as TaskStatisticsList;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 单车详情
const getcardatastatisticsdetails = (
  id: string,
  category_id: string
): Promise<CarDataStatisticsDetail> => {
  return new Promise<CarDataStatisticsDetail>((resolve, reject) => {
    const param = { id, category_id };
    post(
      config.basicNode.node_1 +
        urlName.car_cardatastatistics_details +
        urlToken +
        token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as CarDataStatisticsDetail;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 用户信息获取
const getUserInfo = (): Promise<UserInfoResult> => {
  return new Promise<UserInfoResult>((resolve, reject) => {
    get(config.basicNode.node_1 + urlName.get_user_info + urlToken + token)
      .then((value: ResultValue) => {
        const result = value.data as UserInfoResult;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 用户信息编辑
const userInfoEdit = (param: UserInfo): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.edit_user_info + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 密码修改
const changePassword = (param: ChangePwInfo): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.change_pw + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 用户列表
const userManageList = (param: KeywordParam): Promise<UserManageRes> => {
  return new Promise<UserManageRes>((resolve, reject) => {
    get(
      config.basicNode.node_1 + urlName.usermanagelist + urlToken + token,
      param
    )
      .then((value: ResultValue) => {
        const result = value.data as UserManageRes;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 获取角色列表
const getRoleList = (): Promise<RoleList> => {
  return new Promise<RoleList>((resolve, reject) => {
    get(config.basicNode.node_1 + urlName.role_list + urlToken + token)
      .then((value: ResultValue) => {
        const result = value.data as RoleList;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
//获取用户车辆列表
const getUserCarsList = (param: UserCarsParams): Promise<ResultBean> => {
  if (param) {
    param.category_name = "xdc"; //对应洗地车管理平台专有
  }
  return new Promise<ResultBean>((resolve, reject) => {
    get(config.basicNode.node_1 + urlName.user_cars + urlToken + token, param)
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 获取用户详情
const getuserdetail = (param: RequestUserIds): Promise<RoleDetail> => {
  return new Promise<RoleDetail>((resolve, reject) => {
    get(config.basicNode.node_1 + urlName.user_detail + urlToken + token, param)
      .then((value: ResultValue) => {
        const result = value.data as RoleDetail;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 添加用户
const addUser = (param: AddUserParam): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.add_user + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 编辑用户
const editUser = (param: AddUserParam): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.edit_user + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 删除用户
const userDel = (param: RequestUserIds): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.deluser + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

//客户列表详情
const getCustomerDetails = (param: RequestUserIds): Promise<CustomerDetail> => {
  return new Promise<CustomerDetail>((resolve, reject) => {
    getJava(urlName.costomer_details, param)
      .then((value: ResultValue) => {
        const customerInfoList = value.data as unknown as CustomerDetail;
        resolve(customerInfoList);
      })
      .catch(() => {
        reject();
      });
  });
};
//添加客户
const addCustomer = (param: AddCustomer): Promise<ResultBean> => {
  const formData = new FormData();
  formData.append("organizationName", param.organizationName);
  formData.append("remark", param.remark);
  formData.append("extension", param.extension);
  formData.append("owner", param.owner);
  param.photos?.forEach((file: any) => {
    formData.append("photos", file);
  });
  return new Promise<ResultBean>((resolve, reject) => {
    postJava(urlName.add_costomer, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
//编辑客户
const editCustomer = (param: EditCustomer): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    putJava(urlName.edit_costomer + `/${param.id}`, param)
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 无人值守车辆列表
const unattendedList = (
  param: unattendCarsListObj
): Promise<GetUnattendList> => {
  return new Promise<GetUnattendList>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.unattended_list + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as GetUnattendList;

        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 数据统计:在线车辆数和故障车辆数
const getStatisticsInfo = (): Promise<ResultBean> => {
  const param = {};
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.get_statistics_info + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 唤醒请求
const awakenRequest = (vin: string): Promise<ResultBean> => {
  const param = { vin: vin };
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.wake_up_wake + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = {} as ResultBean;
        result.err_no = value.data.err_no;
        result.err_msg = value.data.err_msg;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 唤醒状态轮询请求
const awakenStatusRequest = (vin: string): Promise<AwakenStatus> => {
  const param = { vin: vin };
  return new Promise<AwakenStatus>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.wake_up_status + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = {} as AwakenStatus;
        result.status = value.data.result?.status;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

// 重启-当前任务状态
const taskStatusRequest = (vin: string): Promise<ResultBean> => {
  const param = { vin: vin };
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.task_status + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};
// 重启-重启
const RestartRequest = (
  vin: string,
  restartType: number
): Promise<ResultBean> => {
  const param = { vin: vin, value: restartType };
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.restart + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

const getCurrentMapId = (vin: string): Promise<string> => {
  const param = { vin: vin };
  return new Promise<string>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.current_map_id + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data.result?.current_map_id as string;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

const getTaskIngInfo = (vin: string): Promise<CleanTaskingInfo> => {
  const param = { vin: vin };
  return new Promise<CleanTaskingInfo>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.tasking_info + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as CleanTaskingInfo;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

const getVehiclePosition = (vin: string): Promise<VehiclePosition> => {
  const param = { vin: vin };
  return new Promise<VehiclePosition>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.vehicle_position + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as VehiclePosition;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

//获取防跌落位置
const getFallPrevention = (vin: string): Promise<ResultValue> => {
  const param = { vin: vin };
  return new Promise<ResultValue>((resolve, reject) => {
    post(
      config.basicNode.node_1 +
        urlName.unattended_fall_prevention +
        urlToken +
        token,
      Qs.stringify(param)
    )
      .then((value) => {
        const result = value.data;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

const getMapElements = (
  vin: string,
  map_id: string
): Promise<MapElement2[]> => {
  const param = { vin: vin, map_id: map_id };
  return new Promise<MapElement2[]>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.map_elements + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data.result as MapElement2[];
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

const getVehicleMapInfo = (
  vin: string,
  map_id: string
): Promise<VehicleMapInfo> => {
  const param = { vin: vin, map_id: map_id };
  return new Promise<VehicleMapInfo>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.vehicle_map_info + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as VehicleMapInfo;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

const snaped = (vin: string): Promise<ResultBean> => {
  const param = { vin: vin };
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.vehicle_snap + urlToken + token,
      Qs.stringify(param)
    )
      .then((value) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

const logBags = (vin: string): Promise<ResultBean> => {
  const param = { vin: vin };
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.log_bags + urlToken + token,
      Qs.stringify(param)
    )
      .then((value) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

const getSnapRecord = (param: VinPram): Promise<snapList> => {
  return new Promise<snapList>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.vehicle_snap_record + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as snapList;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

//无人值守清洗模式详情查询接口
const getCleanModeDetail = (vin: string): Promise<CleanModeDetail> => {
  const param = { vin: vin };
  return new Promise<CleanModeDetail>((resolve, reject) => {
    post(
      config.basicNode.node_1 +
        urlName.get_clean_mode_detail +
        urlToken +
        token,
      Qs.stringify(param)
    )
      .then((value: any) => {
        const result = value.data as CleanModeDetail;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

const getErrorMessage = (vin: string): Promise<ErrorMsg> => {
  const param = {
    vin: vin,
  };
  return new Promise<ErrorMsg>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.vehicle_error_msg + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ErrorMsg;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

// 车辆详情
const changeParameter = (
  vin: string,
  mode_type: number,
  type: number,
  value: number
): Promise<ResultBean> => {
  const param = { vin: vin, mode_type: mode_type, type: type, value: value };
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.change_parameters + urlToken + token,
      Qs.stringify(param)
    ).then((value: ResultValue) => {
      const result = value.data as ResultBean;
      resolve(result);
    });
  });
};

//获取客户列表（新增用户关联客户用）
const getOrgUserList = (param: string): Promise<ResultBean> => {
  const params = {
    username: param,
  };
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.get_org_user_list + urlToken + token,
      Qs.stringify(params)
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

//编辑客户-用户
const editOrgUser = (param: AddOrgUserParam): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.edit_org_user + urlToken + token,
      Qs.stringify(param)
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

//设置用户语言
const setUserLanguage = (param: string): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    post(
      config.basicNode.node_1 + urlName.set_language + urlToken + token,
      Qs.stringify({ language: param })
    )
      .then((value: ResultValue) => {
        const result = value.data as ResultBean;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

// 获取车辆全部车型
const getCarTypeList = (): Promise<ResultBean> => {
  return new Promise<ResultBean>((resolve, reject) => {
    get(config.basicNode.node_1 + urlName.get_car_model + urlToken + token)
      .then((value: ResultValue) => {
        const carInfoList = value.data as ResultBean;
        resolve(carInfoList);
      })
      .catch(() => {
        reject();
      });
  });
};

// Dashboard 相关 API 方法

// 获取设备信息
const getDeviceInfo = (): Promise<DeviceInfoResponse> => {
  return new Promise<DeviceInfoResponse>((resolve, reject) => {
    get(config.basicNode.node_1 + urlName.get_device_info + urlToken + token)
      .then((value: ResultValue) => {
        const result = value.data as DeviceInfoResponse;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

// 获取清扫信息
const getCleanInfo = (): Promise<CleanInfoResponse> => {
  return new Promise<CleanInfoResponse>((resolve, reject) => {
    get(config.basicNode.node_1 + urlName.get_clean_info + urlToken + token)
      .then((value: ResultValue) => {
        const result = value.data as CleanInfoResponse;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

// 获取能耗统计信息
const getEnergyUsage = (): Promise<EnergyUsageResponse> => {
  return new Promise<EnergyUsageResponse>((resolve, reject) => {
    get(config.basicNode.node_1 + urlName.get_energy_usage + urlToken + token)
      .then((value: ResultValue) => {
        const result = value.data as EnergyUsageResponse;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

// 获取任务统计信息
const getTaskCount = (): Promise<TaskCountResponse> => {
  return new Promise<TaskCountResponse>((resolve, reject) => {
    get(config.basicNode.node_1 + urlName.get_task_count + urlToken + token)
      .then((value: ResultValue) => {
        const result = value.data as TaskCountResponse;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

// 获取任务结束统计信息
const getTaskEndCount = (): Promise<TaskEndCountResponse> => {
  return new Promise<TaskEndCountResponse>((resolve, reject) => {
    get(config.basicNode.node_1 + urlName.get_task_end_count + urlToken + token)
      .then((value: ResultValue) => {
        const result = value.data as TaskEndCountResponse;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

// 获取清扫面积统计
const getCleanAreaStatistic = (
  dayNum: number
): Promise<CleanAreaStatisticResponse> => {
  const params = { day_num: dayNum, latest_day: "" };
  return new Promise<CleanAreaStatisticResponse>((resolve, reject) => {
    get(
      config.basicNode.node_1 +
        urlName.get_statistic_clean_area +
        urlToken +
        token,
      params
    )
      .then((value: ResultValue) => {
        const result = value.data as CleanAreaStatisticResponse;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

// 获取清洁时长统计
const getCleanTimeStatistic = (
  dayNum: number
): Promise<CleanTimeStatisticResponse> => {
  const params = { day_num: dayNum, latest_day: "" };
  return new Promise<CleanTimeStatisticResponse>((resolve, reject) => {
    get(
      config.basicNode.node_1 +
        urlName.get_statistic_clean_time +
        urlToken +
        token,
      params
    )
      .then((value: ResultValue) => {
        const result = value.data as CleanTimeStatisticResponse;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

// 获取清扫效率统计
const getCleanRateStatistic = (
  dayNum: number
): Promise<CleanRateStatisticResponse> => {
  const params = { day_num: dayNum, latest_day: "" };
  return new Promise<CleanRateStatisticResponse>((resolve, reject) => {
    get(
      config.basicNode.node_1 +
        urlName.get_statistic_clean_rate +
        urlToken +
        token,
      params
    )
      .then((value: ResultValue) => {
        const result = value.data as CleanRateStatisticResponse;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

// 获取故障统计
const getFaultCount = (dayNum = 7): Promise<FaultCountResponse> => {
  const params = { day_num: dayNum, latest_day: "" };
  return new Promise<FaultCountResponse>((resolve, reject) => {
    get(
      config.basicNode.node_1 + urlName.get_fault_count + urlToken + token,
      params
    )
      .then((value: ResultValue) => {
        const result = value.data as FaultCountResponse;
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
};

export default {
  logIn,
  setToken,
  getCustomerList,
  getUserList,
  getUserCars,
  getMenuList,
  addOrgUser,
  getCountry,
  getAllRolesList,
  getOrgUserDetails,
  changeUser,
  getVehicleManagementList,
  reserveCarClient,
  removeCarClient,
  getVehicleManagementVINList,
  getWorkstationList,
  editWorkStation,
  addWorkStation,
  getOrgUserLists,
  getBindUserList,
  getBindUser,
  delBindUser,
  getCarList,
  getScheduledTasksList,
  getCarBasicInfo,
  passwordReset,
  changeVehicleName,
  carVersion,
  carHwVersion,
  getVisualization,
  getCarsTaskStatistics,
  downloadRawCarsTaskStatistics,
  downloadCarsTaskStatistics,
  getCarTaskStatistics,
  getcardatastatisticsdetails,
  resetPasswd,
  getUserInfo,
  userInfoEdit,
  changePassword,
  userManageList,
  getRoleList,
  getUserCarsList,
  addUser,
  editUser,
  getuserdetail,
  userDel,
  addCustomer,
  editCustomer,
  getCustomerDetails,
  unattendedList,
  getStatisticsInfo,
  awakenRequest,
  awakenStatusRequest,
  taskStatusRequest,
  RestartRequest,
  getCurrentMapId,
  getTaskIngInfo,
  getVehiclePosition,
  getFallPrevention,
  getMapElements,
  getVehicleMapInfo,
  getSnapRecord,
  snaped,
  logBags,
  getCleanModeDetail,
  getErrorMessage,
  changeParameter,
  getOrgUserList,
  editOrgUser,
  downloadTaskStatistics,
  setUserLanguage,
  getCarTypeList,
  getDeviceInfo,
  getCleanInfo,
  getEnergyUsage,
  getTaskCount,
  getTaskEndCount,
  getCleanAreaStatistic,
  getCleanTimeStatistic,
  getCleanRateStatistic,
  getFaultCount,
};
